import React from "react";

import AppWrapper from "../../components/cm/AppWrapper";
import AddClientForm from "../../components/cm/Dashboard/FullPages/ClientForm/AddClientForm";
import SideBarMain from "../../components/cm/SideBarMain";
import { MainNavBarEnum } from "../../components/cm/SideBarMain/MainNavBarEnum";

export default () => {
  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain activeRoute={MainNavBarEnum.ADD_CLIENT} />}>
      <AddClientForm />
    </AppWrapper.WithSidebar>
  );
};
